export const DISPLAYAREAS_LOADING = 'REDUX_SAGA_DISPLAYAREAS_LOADING';
export const DISPLAYAREAS_BY_ID_LOADING = 'REDUX_SAGA_DISPLAYAREAS_BY_ID_LOADING';
export const DISPLAYAREAS_BY_ID_AND_TYPE_LOADING = 'REDUX_SAGA_DISPLAYAREAS_BY_ID_AND_TYPE_LOADING';
export const GET_DISPLAYAREAS_DATA_SUCCESS = 'REDUX_SAGA_GET_DISPLAYAREAS_DATA_SUCCESS';
export const RESET_DISPLAYAREAS = "REDUX_SAGA_RESET_DISPLAYAREAS";
export const GET_DISPLAYAREAS_DATA_ERROR = 'REDUX_SAGA_GET_DISPLAYAREAS_DATA_ERROR';

export const actionGetDisplayAreasByType = (dispatch, type, id, isDisplay) => {
    dispatch({ type: DISPLAYAREAS_LOADING, displayAreaType: type, id: id, isDisplay: isDisplay })
};

export const actionGetDisplayAreasById = (dispatch, id) => {
    dispatch({ type: DISPLAYAREAS_BY_ID_LOADING, payload: id })
};

export const actionGetDisplayAreasByIdAndType = (dispatch, id, type) => {
    dispatch({ type: DISPLAYAREAS_BY_ID_AND_TYPE_LOADING, id, displayAreaType:type })
};

export const actionResetDisplayAreas = (dispatch) => {
    dispatch({ type: RESET_DISPLAYAREAS })
};
